/**
 * Performs a linear interpolation between two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 * @function
 */
module.exports = require('gl-vec4/lerp')



//////////////////
// WEBPACK FOOTER
// ./node_modules/gl-quat/lerp.js
// module id = 1515
// module chunks = 0